//import "./safetyforms.css";
import moment from "moment";
import { useContext, useEffect } from "react";
import "react-dropdown/style.css";
import { formatPhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import ur1 from "../assets/ur1.png";
import { fetchDailyReport, selectDailyReportById } from "../common/slices/dailyreport";
import { selectActiveLocation } from "../common/slices/location";
import Layout, { Content } from "./Layout";
import MediaPreview from "./MediaPreview";
import Row from "./Row";
import SidebarDailyReport from "./SidebarDailyReport";
import { P, P2 } from "./Typography";
import * as _ from 'lodash';
import { ErrorContext } from "../ErrorContext";
import Modal from "./Modal";
import { pathNames } from "../constants";
import { fetchMedia, selectActiveMedia, setActiveMedia, setMedia } from "../common/slices/media";
import SidebarMedia from "./SidebarMedia";



const Logo = styled.img`
    height: 65px;
`

const ReportContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    align-self: center;
    width: 825px;
    padding: 3rem 4rem;
    flex: 1;
`

const ReportSectionHeader = styled.div`
    background-color: black;
    color: white;
    margin: 1rem 0;
    padding: 0.25rem 1rem;
    font-weight: 500;
`

const ReportSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

const MediaSection = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    flex: 1;
`

const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const MediaContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: calc(50% - 0.5rem);
`

const Signature = styled.img`
    objectFit: contain;
    width: 200px;
`

const ReportMedia = ({ media }) => {
    return (
        <MediaContainer>
            <MediaPreview value={media} style={{ flex: 1.3 }} />
            <Attribute>
                <P2>Notes</P2>
                <P>{media?.description}</P>
            </Attribute>
        </MediaContainer>
    )
}

const getValue = (v) => {
    switch (v) {
        case true:
            return 'Yes';
        case undefined:
            return 'NA';
        case false:
            return 'No';
        default:
            return 'NA';
    }
}

const Image = ({ media }) => {
    const location = useSelector(selectActiveLocation);

    if (!media) return;

    return (
        <MediaPreview value={media} style={{ maxHeight: '100%' }} imgStyle={{ objectFit: 'contain', width: '100%', height: '100%' }} />
    )
}


const PreviewImage = ({ id }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const media = useSelector(selectActiveMedia);
    const nav = useNavigate();


    useEffect(() => {
        (async () => {
            try {
                if (id) {
                    await dispatch(fetchMedia(id));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to fetch report.", forSupport: ex.message })
            }
        })()
    }, [id, dispatch]);

    useEffect(() => {
        //When the modal closes, clear the state
        return () => dispatch(setActiveMedia(null));
    }, [])

    return (
        <Modal show bodyStyle={{ height: '90%' }} onClose={() => nav(pathNames.IMAGES)} closeOnEscape>
            <div style={{ flex: 1, display: "flex", flexDirection: "row", maxHeight: '100%' }}>
                <SidebarMedia media={media} />
                <Content style={{ backgroundColor: "#d9d9d9", padding: '1rem', overflowY: 'auto' }}>
                    <Image media={media} />
                </Content>
            </div>
        </Modal>
    );
};
export default PreviewImage;
